export default __webpack_public_path__ + "static/media/PREWEDDING_compressed.d43b4447.pdf";